import {testPlaceholder} from "../../../../tests/test-data";

export const onChange = (e) => {
  return e.target.value;
};
export const NInputDefProps = {
  placeholder: testPlaceholder,
  value: '',
  onChange: onChange
};